module.exports = __webpack_public_path__ + "static/media/8.54d097e6.wav";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row4/8.wav
// module id = 83
// module chunks = 0